<app-layout>
  <app-layout-title>
    {{ 'ACCOUNT.my_profile' | translate }}
  </app-layout-title>

  <app-layout-content>
    @if (user) {
      <div class="grid">
        <div class="image">
          <img src="assets/img/user.png">
        </div>
        <div class="info">
          <p>{{ 'ACCOUNT.name' | translate }}: {{ user.fullName }}</p>
          <p>{{ 'ACCOUNT.username' | translate }}: {{ user.login }}</p>
          <p>{{ 'ACCOUNT.phone' | translate }}: {{ user.phone }}</p>
          <p>{{ 'AUTH.email' | translate }}: {{ user.email }}</p>
          <p>{{ 'ACCOUNT.role' | translate }}: {{ user.role | label: 'user-roles' | async }}</p>
          <p>{{ 'ACCOUNT.registration_date' | translate }}: <app-date [date]="user.registeredAt" [needAgo]="false"></app-date></p>
        </div>
        <div class="assigned-projects">
          <div>{{ 'ACCOUNT.assigned-projects' | translate }}:</div>
          <div class="projects-grid">
            @for (project of user.assignedProjects; track project) {
              <app-project-view
                [iso]="project.isoCode"
                [name]="project.name">
              </app-project-view>
            }
          </div>
        </div>
        <div class="languages">
          {{ 'LANGUAGE.lang' | translate }}: {{ 'LANGUAGE.current_lang' | translate }} <br>
          <button mat-icon-button (click)="selectLanguage('en')" matTooltip="English"
            [attr.aria-label]="'LANGUAGE.en' | translate" data-language="en">
            <app-flag-icon code="gbr"></app-flag-icon>
          </button>
          <button mat-icon-button (click)="selectLanguage('ru')" matTooltip="Русский"
            [attr.aria-label]="'LANGUAGE.ru' | translate" data-language="ru">
            <app-flag-icon code="rus"></app-flag-icon>
          </button>
        </div>
      </div>
    }
  </app-layout-content>
</app-layout>
